/**
 * Проверка соединения GOST TLS
 */
let gost
export async function gosttls () {
  if (gost !== undefined) {
    return gost
  } else {
    return await makeRequestTLS().then(response => {
      const res = JSON.parse(response)
      gost = res.gost
      return res.gost
    })
  }
}
async function makeRequestTLS () {
  const oReqGOST = new XMLHttpRequest()
  oReqGOST.open('GET', 'https://gost.cryptopro.ru/info.php', true)

  let responseText

  try {
    await new Promise((resolve, reject) => {
      oReqGOST.onload = resolve
      oReqGOST.onerror = reject
      oReqGOST.send()
    })
    responseText = oReqGOST.responseText
  } catch (err) {
    // обработка ошибки
    console.log('Request TLS error')
  }

  return responseText
}

/*

function printMessage(gost) {
  if (gost === undefined) return;
  var targetElement = document.getElementById('gostcheck');
  if (gost) {
    // positive
    targetElement.innerHTML = '<div style="margin-top:20px; margin-bottom:20px; border-left:7px solid #00A969;background:#F6F6F6; display:flex; align-items: center; justify-content: start;" _mce_style="margin-top: 20px; margin-bottom: 20px; border-left: 7px solid #00A969; background: #F6F6F6; display: flex; align-items: center; justify-content: start;"> <div style="padding:15px;" _mce_style="padding: 15px;"> <b><span style="font-size:14px;" _mce_style="font-size: 14px;">Ваш браузер поддерживает ГОСТ TLS</span></b><br> Всё в порядке, можно двигаться дальше, это необходимое условие для тестирования. </div> </div>';
  } else {
    // negative
    targetElement.innerHTML = '<div style="margin-top:20px; margin-bottom:20px; border-left:7px solid #FF1635;background:#F6F6F6; display:flex; align-items: center; justify-content: start;" _mce_style="margin-top: 20px; margin-bottom: 20px; border-left: 7px solid #FF1635; background: #F6F6F6; display: flex; align-items: center; justify-content: start;"> <div style="padding:15px;" _mce_style="padding: 15px;"> <b><span style="font-size:14px;" _mce_style="font-size: 14px;">Ваш браузер не поддерживает ГОСТ TLS</span></b><br>Вам необходим браузер с поддержкой криптографии ГОСТ (<a href="/products/chromium-gost" _mce_href="/products/chromium-gost">например</a>) и установленным <a href="/products/csp" _mce_href="/products/csp">КриптоПро CSP</a>. Это необходимое условие для продолжения, без этого часть ссылок тестирования ГОСТ TLS не будет открываться совсем. </div> </div>';
  }
}
*/
